var _rect, _rect2, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunningtext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 33.074,
    cy: 28.335,
    r: 15,
    id: "gradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.7451% 45.098% 3.5294%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0% 28.096% 0%)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 33.074,
    cy: 28.335,
    r: 15,
    id: "gradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.7451% 45.098% 3.5294%)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0% 28.096% 0%)"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7,
    stroke: "#D8D8D8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(7, 115, 9)",
      fontFamily: "Arial, sans-serif",
      fontSize: "7.4px",
      fontWeight: 700,
      whiteSpace: "pre"
    },
    transform: "matrix(2.0970330238342285, 0, 0, 2.0970330238342285, -32.36001968383789, -21.77640533447266)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "url('#gradient-1')"
    },
    x: 18.074,
    y: 27.196
  }, "Running"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 18.074,
    dy: "1em"
  }, "\u200B")), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "url('#gradient-4')"
    }
  }, "Text")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningtext);
export default __webpack_public_path__ + "static/media/runningtext.193d332815644ccf3ad895df272f9aa7.svg";
export { ForwardRef as ReactComponent };